export default "__VITE_ASSET__C$IiFM_m__"